import {BarcodeFormatModel} from './barcode-format.model';
import {CustomerModel} from './customer.model';
import { WorkshopConfigurationModel } from './workshop-configuration.model';

export class ConfigurationModel {
    public host: string;
    public primaryAddress: string;
    public secondaryAddress: string;
    public port: number;
    public gpsTimeout: number;
    public databaseVersion: number;
    public PODOnly: boolean;
    public apikey: string;
    public selectedOperator: number;
    public selectedDepot: number;
    public selectedEngineer: number;
    public selectedPrinter: string;
    public printerCopies: number;
    public custDateTime: string;
    public contactDateTime: string;
    public equipmentDateTime: string;
    public productDateTime: string;
    public siteDateTime: string;
    public contractDateTime: string;
    public haccessDateTime: string;
    public saccessDateTime: string;
    public hratesDateTime: string;
    public priceListDetailsDateTime: string;
    public ptSerialDateTime: string;
    public productBarcodeDateTime: string;
    public selectedBarcodeDevice: MediaDeviceInfo;
    public selectedScannerFormats: BarcodeFormatModel[];
    public barcodeTorchEnabled: boolean;
    public selectedCashAccount: string;
    public automaticUploadDockets: boolean;
    public standardContractTime: string;
    public standardReturnTime: string;
    public daysOfCompletedActions: number;
    public showActionsTab: boolean;
    public showJobHoursComponent: boolean;
    public suggestAddTransportFee: boolean;
    public startEquipSelectedFromAllItems: boolean;
    public offLineMode: boolean;
    public wifiOnlyMode: boolean;
    public podOnly: boolean;
    public chargeDeliveryAndCollection: boolean;
    public queuedDocumentsInMainScreen: boolean;
    public counterSigningMode: boolean;
    public lastMattressScanned: string;
    public currentCustomer: CustomerModel;
    public showCustomerSigComponent: boolean;
    public workshopConfiguration: WorkshopConfigurationModel;
    public disableSelfAssignment: boolean;
    public documentBeanQueueOrdering: string;

    [x: string]: any;
}
